import { app } from '../../../bootstrap/core';
import { userFormComponent } from './userForm.component';
import { UserFormServiceProvider } from './userForm.service.provider';

app.component('userForm', userFormComponent);
app.provider('userFormService', UserFormServiceProvider);



// WEBPACK FOOTER //
// ./src/app/common/ui/userForm/userForm.js